<template>
    <v-container>
        <v-text-field
            label="What is your MCAT score?"
            v-model="user.mcatScore"
            type="number"
        ></v-text-field>
        <v-text-field
            label="What is your science GPA?"
            v-model="user.scienceGpa"
            type="number"
        ></v-text-field>
        <v-text-field
            label="What is your Total GPA?"
            v-model="user.gpaScore"
            type="number"
        ></v-text-field>
        <v-autocomplete
            label="State"
            :items="states"
            v-model="user.state"
        ></v-autocomplete>
        <v-btn color="primary" @click="setUser(user)">Next</v-btn>
    </v-container>
</template>

<script>
import States from '../data/states.json';

export default {
    name: 'home',
    data: () => ({
        user: {
            mcatScore: null,
            gpaScore: null,
            scienceGpa: null,
            state: null,
        },
        states: States,
    }),
    created() {
        this.$store.dispatch('loadFromSession');

        if (
            window.sessionStorage.getItem('user') &&
            window.sessionStorage.getItem('answer') &&
            window.sessionStorage.getItem('score')
        ) {
            this.$router.push(`results`);
        }
    },
    methods: {
        setUser(user) {
            this.$store.commit('setUser', user);
            this.next();
        },
        next() {
            this.$router.push('question/1');
        },
    },
};
</script>
